<template>
  <modal
    width="35"
    :show-modal="showModal"
    @close-modal="$emit('close-modal')"
  >
    <div class="flex my-4 flex-col gap-4 items-center justify-center">
      <div class="flex flex-col gap-2 justify-center">
        <qrcode /> 
        <div class="flex gap-4">
          <div class="text-lightGrey">Shipping Code</div>
          <div class="">{{booking.reference ? booking.reference : 'N/A'}}</div>
        </div>
      </div>  
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Name of Item</div>
        <div>Clothes</div>
      </div>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Item Description</div>
        <div>Bale of clothes, 20 bags</div>
      </div>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Packaging Type</div>
        <div>Bagged</div>
      </div>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Special Handling</div>
        <div>None Required</div>
      </div>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Weight</div>
        <div>50kg</div>
      </div>
      <hr>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Sender</div>
        <div>Emodi Ibukunle</div>
      </div>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Sender Phone No.</div>
        <div>08038228282</div>
      </div>
      <hr>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Reciever</div>
        <div>Emodi Ibukunle</div>
      </div>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Reciever Phone No.</div>
        <div>08038228282</div>
      </div>
      <div class="flex justify-between w-100">
        <div class="text-lightGrey">Reciever Address</div>
        <div>2, Odenigbo Road, Nsukka, Enugu</div>
      </div>

      <div class="button-wrapper">
        <div>
          <base-button text="Request Handoff Receipt" />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      reason: "",
    };
  },
};
</script>

<style scoped>
hr{
  border: 1px dashed #A5ADB7;
}
.delete-modal {
  text-align: center;
}
</style>
